import React from 'react';
import { Link } from 'react-router-dom';


const CookiesPolicy = () => {
  return (
    <div className="cookies-policy">
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(assets/img/bg-img.png)' }}></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Cookies Policy</h1>
            <ul className="bread-crumb clearfix">
              <li> <Link href="/">Home </Link></li>
              <li>Cookies Policy</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="service-details industries-details">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 content-side">
              <div className="service-details-content">
                <div className="content-three">
                  <div className="upper-box">
                    <h3>Cookies Policy</h3>
                    <p>
                      At SNKB Berings, we utilize cookies to enhance your browsing experience on our websites. By continuing to use this site, you consent to the use of these cookies.
                    </p>
                    <br />
                    <p>
                      Our website employs cookies for anonymous analysis of website traffic, aiding us in improving website functionality and effectiveness. With your consent, we also utilize cookies to personalize content and advertisements.
                    </p>
                    <br />
                    <p>
                      Cookies are small files that are transferred to your computer's hard drive via your web browser, enabling our systems to recognize your browser and capture certain information, such as your IP address, operating system, and browsing activity. We collect data about your device, browsing actions, and website usage patterns automatically to enhance your experience and provide improved services.
                    </p>
                    <br />
                    <p>
                      We may engage third-party service providers to assist us in understanding our site visitors better. These providers are only permitted to use the collected information to help us improve our business practices.
                    </p>
                    <br />
                    <p>
                      You have the option to manage your cookie preferences through your browser settings. Please note that disabling cookies may limit access to certain features of our website, but Authorized Dealers can still place orders over the telephone.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiesPolicy;
